enum ActionTypes {
    GET_JIRA_INTEGRATION_INFO = "jiraIntegration/getJiraIntegrationInfo",
    GET_JIRA_INTEGRATION_INFO_FINISHED = "jiraIntegration/getJiraIntegrationInfoFinished",
    SET_JIRA_INTEGRATION_INFO = "jiraIntegration/setJiraIntegrationInfo",
    SET_JIRA_HINT_SEEN = "jiraIntegration/setJiraIntegrationHintSeen",
    UPDATE_JIRA_DEPLOYMENT_URL = "jiraIntegration/updateJiraIntegrationUrl",
}

export default ActionTypes;
